/* eslint-disable */
/* eslint-disable prefer-template */
/* eslint-disable max-len */
/* eslint linebreak-style: ["error", "windows"] */
// react
import React, { useState } from "react";
import axios from "axios";
import { MyApiUrl, ViewImg } from "../services/service";

import Currency from "../shared/Currency";
import { Link, useLocation, useHistory } from "react-router-dom";
// third-party
import { Helmet } from "react-helmet-async";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// application
import PageHeader from "../shared/PageHeader";
import "./Trackorder.css";

// data stubs
import theme from "../../data/theme";
import "../../scss/order_tracking.css";
import "../../scss/custom.css";

function SiteOrderDetails(props) {
    const history = useHistory();
    const breadcrumb = [
        { title: "Home", url: "/" },
        { title: "Track Order", url: "/shop/track-order" },
        { title: "Order Details", url: "" },
    ];

    const [CardData, setCardData] = useState([]);
    const [CardView, setCardView] = useState(false);
    const [OrderStatus, setOrderStatus] = useState({
        One: "step",
        Two: "step",
        Three: "step",
        Four: "step",
        Five: "step",
    });

    const orderDetails = props.location.state.OrderDetails[0];

    const getMonthName = (monthNumber) => {
        const date = new Date();
        date.setMonth(monthNumber - 1);

        return date.toLocaleString("en-US", { month: "long" });
    };

    const SplitDate = (OrderDate) => {
        const MainDate = OrderDate.split("T");
        const SplitT = MainDate[0];
        const OrderDates = SplitT.split("-");
        const FinalDate = OrderDates[2] + " " + getMonthName(OrderDates[1]) + ", " + OrderDates[0];
        return FinalDate;
    };

    const GetAddress = async () => {
        await axios.get(MyApiUrl + "OrderItems/" + orderDetails.orders_pkid + "").then((response) => {
            console.log(response);
            if (response.data.length > 0) {
                setCardData(response.data);
                console.log(CardData);
                setCardView(true);
                if (orderDetails.orders_status_id == 0) {
                    setOrderStatus({
                        ...OrderStatus,
                        One: "step completed",
                        Two: "step",
                        Three: "step",
                        Four: "step",
                        Five: "step",
                    });
                } else if (orderDetails.orders_status_id == 1) {
                    setOrderStatus({
                        ...OrderStatus,
                        One: "step completed",
                        Two: "step completed",
                        Three: "step",
                        Four: "step",
                        Five: "step",
                    });
                } else if (orderDetails.orders_status_id == 2) {
                    setOrderStatus({
                        ...OrderStatus,
                        One: "step completed",
                        Two: "step completed",
                        Three: "step completed",
                        Four: "step",
                        Five: "step",
                    });
                } else if (orderDetails.orders_status_id == 3) {
                    setOrderStatus({
                        ...OrderStatus,
                        One: "step completed",
                        Two: "step completed",
                        Three: "step completed",
                        Four: "step completed",
                        Five: "step",
                    });
                } else if (orderDetails.orders_status_id == 4) {
                    setOrderStatus({
                        ...OrderStatus,
                        One: "step completed",
                        Two: "step completed",
                        Three: "step completed",
                        Four: "step completed",
                        Five: "step completed",
                    });
                }
            } else {
                setCardData([]);
            }
        });
    };
    React.useEffect(() => {
        GetAddress();
    }, []);

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Order Details — ${theme.name}`}</title>
            </Helmet>
            <PageHeader breadcrumb={breadcrumb} />
            <div className="container">
                {CardView && (
                    <div className="track-order-page">
                        {/* ===== ORDER HEADER ===== */}
                        <div className="track-header">
                            <Link to="/shop/track-order" className="back-link">
                                ← Back to Track Order
                            </Link>

                            <h2>
                                Order <span>{orderDetails.orders_number}</span>
                            </h2>

                            <p>
                                Placed on <strong>{SplitDate(orderDetails.orders_date)}</strong>
                            </p>

                            <span className="status-badge">{orderDetails.orders_status}</span>
                        </div>

                        {/* ===== TRACKING TIMELINE ===== */}
                        {/* ===== ORDER TRACKING ===== */}
                        <div className="track-card">
                            <h4 className="track-title">Order Tracking</h4>

                            {orderDetails.orders_status_id === 5 ? (
                                <div className="track-rejected">
                                    <i className="fas fa-times-circle" />
                                    <span>Order Rejected</span>
                                </div>
                            ) : (
                                <div className="track-timeline">
                                    <div className={`track-step ${orderDetails.orders_status_id >= 0 ? "active" : ""}`}>
                                        <div className="icon">
                                            <i className="fas fa-shopping-cart" />
                                        </div>
                                        <span>Placed</span>
                                    </div>

                                    <div className={`track-step ${orderDetails.orders_status_id >= 1 ? "active" : ""}`}>
                                        <div className="icon">
                                            <i className="fas fa-check-circle" />
                                        </div>
                                        <span>Confirmed</span>
                                    </div>

                                    <div className={`track-step ${orderDetails.orders_status_id >= 2 ? "active" : ""}`}>
                                        <div className="icon">
                                            <i className="fas fa-box-open" />
                                        </div>
                                        <span>Packed</span>
                                    </div>

                                    <div className={`track-step ${orderDetails.orders_status_id >= 3 ? "active" : ""}`}>
                                        <div className="icon">
                                            <i className="fas fa-truck" />
                                        </div>
                                        <span>Dispatched</span>
                                    </div>

                                    <div className={`track-step ${orderDetails.orders_status_id >= 4 ? "active" : ""}`}>
                                        <div className="icon">
                                            <i className="fas fa-home" />
                                        </div>
                                        <span>Delivered</span>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* ===== ITEMS ===== */}
                        <div className="track-card">
                            <h4>Items</h4>

                            {CardData[0].orders_items.map((item) => (
                                <div key={item.order_item_pkid} className="item-row">
                                    <div>
                                        <div className="item-name">{item.product_name}</div>
                                        <div className="item-meta">
                                            {item.product_unit_weight} × {item.order_item_quantity}
                                        </div>
                                    </div>

                                    <div className="item-price">
                                        <Currency value={item.order_item_amount} />
                                    </div>
                                </div>
                            ))}

                            <div className="summary">
                                <div>
                                    <span>Subtotal</span>
                                    <Currency value={CardData[0].orders_sub_total} />
                                </div>
                                <div>
                                    <span>Shipping</span>
                                    <Currency value={CardData[0].orders_shipping_amount} />
                                </div>
                                <div>
                                    <span>Discount</span>
                                    <Currency value={CardData[0].orders_coupon_discount} />
                                </div>
                                <div className="grand">
                                    <span>Total</span>
                                    <Currency value={CardData[0].orders_grand_total} />
                                </div>
                            </div>
                        </div>

                        {/* ===== ADDRESS ===== */}
                        <div className="track-card">
                            <h4>Shipping Address</h4>

                            {CardData[0].orders_address.map((addr) => (
                                <div key={addr.user_address_phone} className="address-box">
                                    <strong>{addr.user_address_name}</strong>
                                    <p>
                                        {addr.user_address_house_no}, {addr.user_address_street}
                                        <br />
                                        {addr.area_name}, {addr.city_name}, {addr.state_name}
                                        <br />
                                        {addr.country_name} - {addr.user_address_zipcode}
                                    </p>
                                    <span>📞 {addr.user_address_phone}</span>
                                </div>
                            ))}
                        </div>

                        {/* ===== COUPON ===== */}
                        <div className="track-card">
                            <h4>Coupon</h4>

                            {CardData[0].orders_coupons.length > 0 ? (
                                CardData[0].orders_coupons.map((c) => (
                                    <div key={c.coupon_code} className="coupon-box">
                                        <div>
                                            <b>{c.member_coupon_type}</b>
                                        </div>
                                        <div>Code: {c.coupon_code}</div>
                                        <div>
                                            Saved: <Currency value={CardData[0].orders_coupon_discount} />
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p className="muted">No coupon applied</p>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}

export default SiteOrderDetails;
